import { render, staticRenderFns } from "./premiumTemplateModel.vue?vue&type=template&id=14c4d8fa&scoped=true"
import script from "./premiumTemplateModel.vue?vue&type=script&lang=js"
export * from "./premiumTemplateModel.vue?vue&type=script&lang=js"
import style0 from "./premiumTemplateModel.vue?vue&type=style&index=0&id=14c4d8fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4d8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c4d8fa')) {
      api.createRecord('14c4d8fa', component.options)
    } else {
      api.reload('14c4d8fa', component.options)
    }
    module.hot.accept("./premiumTemplateModel.vue?vue&type=template&id=14c4d8fa&scoped=true", function () {
      api.rerender('14c4d8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/productManage/productFrom/premiumTemplateModel.vue"
export default component.exports